import 'core-js/fn/symbol/for';
import 'core-js/fn/symbol/iterator';
import 'whatwg-fetch';

document.addEventListener('DOMContentLoaded', async () => {
    try {
        const browserClasses = await import('./modules/browser-classes');
        browserClasses.default();

        const sharePopup = await import('./modules/share-popup');
        sharePopup.default();

        const smoothScroll = await import('./modules/smooth-scroll');
        smoothScroll.default();

        const productTabs = await import('./modules/woocommerce/product-tabs');
        productTabs.default();

        const attributeSwatchToggle = await import('./modules/woocommerce/attribute-swatch-toggle');
        attributeSwatchToggle.default();

        const wooPriceSwitch = await import('./modules/woocommerce/woo-price-switch');
        wooPriceSwitch.default();

        const imageCarouselSegmented = await import('./modules/image-carousel-segmented');
        imageCarouselSegmented.default();

        const imageGallery = await import('./modules/image-gallery');
        imageGallery.default();

        const productCarousel = await import('./modules/product-carousel');
        productCarousel.default();

        const productGallery = await import('./modules/woocommerce/product-gallery');
        productGallery.default();

        const supportSidebar = await import('./modules/support-sidebar');
        supportSidebar.default();

        const accordions = await import('./modules/accordions');
        accordions.default();

        const supportFiltering = await import('./modules/support-filtering');
        supportFiltering.default();

        const wooNotices = await import('./modules/woocommerce/woo-notices');
        wooNotices.default();

        const logoMarquee = await import('./modules/logo-marquee');
        logoMarquee.default();

        const filterToggles = await import('./modules/filter-toggles');
        filterToggles.default();

        const archiveFiltering = await import('./modules/woocommerce/archive-filtering');
        archiveFiltering.default();

        const sizingVariables = await import('./modules/sizing-variables');
        sizingVariables.default();

        const pageMenu = await import('./modules/page-menu');
        pageMenu.default();

        const searchToggle = await import('./modules/search-toggle');
        searchToggle.default();

        const ajaxSearch = await import('./modules/ajax-search');
        ajaxSearch.default();

        const stickyMenu = await import('./modules/sticky-menu');
        stickyMenu.default();

        const bannerLinks = await import('./modules/banner-links');
        bannerLinks.default();

        const quantitySpinners = await import('./modules/woocommerce/quantity-spinners');
        quantitySpinners.default();

        const categoryScroll = await import('./modules/category-scroll');
        categoryScroll.default();

        const mobileProductTabs = await import('./modules/mobile-product-tabs');
        mobileProductTabs.default();

        const disableProductImageLinks = await import('./modules/disable-product-image-links');
        disableProductImageLinks.default();

        const wysiwygFixer = await import('./modules/wysiwyg-fixer');
        wysiwygFixer.default();

        const basketTotal = await import('./modules/woocommerce/basket-total');
        basketTotal.default();

        const blogLayout = await import('./modules/blog-layout');
        blogLayout.default();

        const archiveLoadMore = await import('./modules/archive-load-more');
        archiveLoadMore.default();

        const mobileGalleryControls = await import('./modules/mobile-gallery-controls');
        mobileGalleryControls.default();

        const galleryFilter = await import('./modules/gallery-filter');
        galleryFilter.default();

        const galleryControls = await import('./modules/gallery-controls');
        galleryControls.default();

        const galleryStickyMenu = await import('./modules/gallery-sticky-menu');
        galleryStickyMenu.default();

        const quoteCategories = await import('./modules/quote/quote-categories');
        quoteCategories.default();

        const quoteArchive = await import('./modules/quote/quote-archive');
        quoteArchive.default();

        const quoteDetail = await import('./modules/quote/quote-detail');
        quoteDetail.default();

        const savedQuoteTable = await import('./modules/quote/saved-quote-table');
        savedQuoteTable.default();

        const locationLists = await import('./modules/location-lists');
        locationLists.default();

        const iconGrids = await import('./modules/icon-grids');
        iconGrids.default();

        const iconCarousel = await import('./modules/icon-carousel');
        iconCarousel.default();

        const titledGallery = await import('./modules/titled-gallery');
        titledGallery.default();

        const pipeskirts = await import('./modules/pipeskirts');
        pipeskirts.default();

        const stagedVideo = await import('./modules/staged-video');
        stagedVideo.default();

        const steppedText = await import('./modules/stepped');
        steppedText.default();

        const steppingImages = await import('./modules/stepping-images');
        steppingImages.default();

        const blurImages = await import('./modules/blur-images');
        blurImages.default();

        const InternationalSites = await import('./modules/international-sites');
        InternationalSites.default();

        const menuHasScrolled = await import('./modules/menu-has-scrolled');
        menuHasScrolled.default();

        const designSlider = await import('./modules/design-slider');
        designSlider.default();

        const sliderProgress = await import('./modules/slider-progress');
        sliderProgress.default();

        const processForms = await import('./modules/process-forms');
        processForms.default();

        const marketingPopUp = await import('./modules/marketing-pop-up');
        marketingPopUp.default();

        const dialogPopUp = await import('./modules/dialog-pop-up');
        dialogPopUp.default();

        const downloadMarketingPopup = await import('./modules/download-marketing-popup');
        downloadMarketingPopup.default();

        const googleAnalytics = await import('./modules/google-analytics');
        googleAnalytics.default();

        const cf7Dealer = await import('./modules/cf7-dealer');
        cf7Dealer.default();

        const siteFlash = await import('./modules/site-flash');
        siteFlash.default();

        const categoryGridSize = await import('./modules/category-grid-size');
        categoryGridSize.default();

        const dialogSetup = await import('./modules/dialog-setup');
        dialogSetup.default();

        const videoModalControls = await import('./modules/video-modal-controls');
        videoModalControls.default();

        const steps = await import('./modules/steps');
        steps.default();

        const stickyImage = await import('./modules/sticky-image');
        stickyImage.default();

        const DownloadDisplayToggles = await import('./modules/download-display-toggles');
        DownloadDisplayToggles.default();

        const DownloadFiltering = await import('./modules/download-filtering');
        DownloadFiltering.default();

        const formControls = await import('./modules/form-controls');
        formControls.default();

        const tooltips = await import('./modules/tooltips.js');
        tooltips.default();

        const lottie = await import('./modules/lottie.js');
        lottie.default();

        const standardsSwapper = await import('./modules/standards-swapper');
        standardsSwapper.default();

        const headingScrollShow = await import('./modules/heading-scroll-show');
        headingScrollShow.default();

        const videoVisibility = await import('./modules/video-visibility');
        videoVisibility.default();

        const visibilityHandler = await import('./modules/visibility-handler');
        visibilityHandler.default();

        const progressHandler = await import('./modules/progress-handler');
        progressHandler.default();

        const sustainabilitySidebar = await import('./modules/sustainability-sidebar');
        sustainabilitySidebar.default();

        const sustainabilityVideoLocking = await import('./modules/sustainability-video-locking');
        sustainabilityVideoLocking.default();

        // ... (import and initialize the rest of your modules)
    } catch (err) {
        console.error('Failed to load some modules:', err);
    }
});
